import { useEffect, useState } from 'react';
import { businessDayStart, nextCalendarDate, toBusinessDate } from 'config/time';

/** 業務時間帯（会社の時間帯）の今日。0時と画面復帰で更新し、開いたままでも暦日が古くならない。 */
export function useBusinessDate(): string {
  const [today, setToday] = useState(() => toBusinessDate(new Date()));

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const refresh = () => {
      const now = new Date();
      const date = toBusinessDate(now);
      setToday(date);
      // EV-116 段階2。次の0時は「翌日の00:00」を時間帯の名前から求める（端末の時間帯に依存しない）。
      // 「今日の始まり＋24時間」では、夏時間の切り替えの日（23・25時間）に1時間ずれていた。
      const nextMidnight = Date.parse(businessDayStart(nextCalendarDate(date)));
      clearTimeout(timer);
      timer = setTimeout(refresh, Math.max(1, nextMidnight - now.getTime()));
    };
    refresh();
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, []);

  return today;
}
